module.exports = __webpack_public_path__ + "img/test2.fb871def.jpg";